import React from "react";
import styles from "./Header.module.css"; // Importing the modular CSS
import headerImage from "../../assets/headerImage.png";
import subImage1 from "../../assets/subImage1.png";
import Image31 from "../../assets/Image31.png";
import Image32 from "../../assets/Image32.png";
import Quickaccess from "./Quickaccess";
import Carousel from "react-bootstrap/Carousel";
import carosal1 from "../../assets/carosalimage1.png";
import carosal2 from "../../assets/carosalimage2.png";
import carosal3 from "../../assets/carosalimage3.png";
import carosal4 from "../../assets/carosalimage4.png";
import carosal6 from "../../assets/carosal6.png";
import logo1 from "../../assets/Logo Client 1.png";
import logo2 from "../../assets/Logo Client 2.png";
import logo3 from "../../assets/Logo Client 3.png";
import logo4 from "../../assets/Logo Client 4.png";
import logo5 from "../../assets/Logo Client 5.png";
import { Container, Row, Col, Image } from "react-bootstrap";
import Frame from "../../assets/Frame.png"
import Frame1 from "../../assets/Frame 1.png"
import Team1 from "../../assets/Item - Team 10.png"
import Team2 from "../../assets/Item - Team 11.png"
import Team3 from "../../assets/Item - Team 12.png"
import Frame2 from "../../assets/Frame2.png"
import Custumcarousal from "../../components/Custumcarousal";
const HomePage = () => {
  return (
    <>
      <section className={styles.upperSection}>
         <div className={styles.mainContainer}>
          <div className={styles.content}>
            <div className={styles.subcontent1}>
              <h2 className={styles.subtitle}>
                Elevating Excellence, Driving Impact
              </h2>
              <h1 className={styles.title}>
                Empowering Growth Through Data, Diversity, and Innovation.
              </h1>
            </div>
            <p className={styles.description}>
              DUNN, PIERRE, BARNETT & CO. (DPBA) is a leading human resource
              development and education and training management consulting
              company in the CARICOM region, specialising in Technical and
              Vocational Training and Education, Labour Market Assessments,
              Capacity-Building, Research, and Business Development services. It
              is registered in Ontario, Canada, and Jamaica. It has an excellent
              track record in building capacity and strengthening institutions
              using the competency-based approach to education and training
              stipulated by CARICOM.
            </p>
            <div className={styles.button}>
              <button className={styles.contactButton}>CONTACT US</button>
              <button className={styles.startButton}>GET STARTED</button>
            </div>
          </div>
        </div>
      </section>
        <div className={styles.mainContainer}>
        <section className="container">
        <div className="row">
          <div className="col-xl-6 order-lg-1 order-2 col-lg-6 d-flex align-items-center mt-lg-0 mt-4">
            <div className="row ">
              <div className="col-6 pe-sm-2 pe-0  col-6 d-flex align-items-stretch">
                <div className={`${styles.zoomEffect} `}>
                  <img
                    src={subImage1}
                    className="w-100 h-100"
                    alt=""
                    srcset=""
                    style={{ objectFit: "cover"}}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className={`${styles.zoomEffect} col-3`}>
                  <img
                    src={Image31}
                    className="w-100 h-50"
                    alt=""
                    srcset=""
                    style={{ objectFit: "cover" }}
                  />
                </div>
                <div className={`${styles.zoomEffect} mt-3 col-3`}>
                  <img
                    src={Image32}
                    className="w-100 h-50"
                    alt=""
                    srcset=""
                    style={{ objectFit: "cover" }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6 order-lg-2 order-1 col-lg-6 d-flex align-items-center ps-lg-4">
            <div>
              <div className={`${styles.sectionOnetext} fw-500`}>ABOUT US</div>
              <div
                className={`${styles.sectionCommonHeadig} mt-xl-2 mt-lg-0 mt-2`}
              >
                Building Trust Through Community Reviews
              </div>
              <div className="fw-300 mt-xl-2 mt-lg-0 mt-2">
              At DPB Global, we are dedicated to advancing human potential
                through innovative solutions in consulting, data analysis, and
                workforce development. Our mission is to empower businesses and
                individuals by leveraging cutting-edge technologies, like AI and
                machine learning, alongside a deep understanding of diverse
                global populations. With a focus on inclusivity and
                socio-economic growth, we help our clients navigate complex
                challenges, from labor market assessments to corporate
                immigration, driving sustainable success in a rapidly evolving
                world.
              </div>
              <button className="btn btn-primary mt-4 px-4 rounded-pill">
                Read More
              </button>
            </div>
          </div>
        </div>
      </section>
        <Quickaccess />
        <Custumcarousal />
        <div className="row align-items-center gap-2">
          <div className="col-lg-6 col-md-12 ">
            <img
              src={carosal6}
              alt="join us"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className="col-lg-4 col-md-12">
            <span>Comprehensive </span>
            <span>Consultation Services</span>
            <ul>
              <li>Technical Vocational education and Training</li>
              <li>Competency-based education and training</li>
              <li>Labour Market Reasearch and Social surveys</li>
              <li>Workforce Development</li>
              <li>Instruction Design</li>
              <li>Management Consulting</li>
              <li>Capacity Bulding</li>
              <li>Business Development</li>
              <li>Reasearch</li>
              <li>Block Data</li>
            </ul>
          </div>
        </div>
       






       {/* another */}
        <div>
        <div className={styles.companylogo}>
          <div className={styles.logoContainer}>
            <img src={logo1} alt="Logo 1" className={styles.logo} />
            <img src={logo2} alt="Logo 2" className={styles.logo} />
            <img src={logo3} alt="Logo 3" className={styles.logo} />
            <img src={logo4} alt="Logo 4" className={styles.logo} />
            <img src={logo1} alt="Logo 5" className={styles.logo} />
          </div>
        </div>
    </div>
  <div className=" d-flex justify-content-center align-items-center">
          <img src={Frame} className={`${styles.Frame} img-fluid d-block max-auto`} />
        </div>

        <div className=" d-flex justify-content-center align-items-center">
          <img src={Frame1} className={`${styles.Frame1} img-fluid d-block max-auto`} ></img>
        </div>
       
        <div className=" ">
          <div className={`${styles.Team}`}>
          <img src={Team1} className={`${styles.Team1} img-fluid d-block `}></img>
          <img src={Team2} className={`${styles.Team2} img-fluid d-block `}></img>
          <img src={Team3} className={`${styles.Team3} img-fluid d-block`}></img>
          </div>
          </div>
     
       {/* another */}
      </div>
  
    </>
  );
};

export default HomePage;
